import { RequestType } from '@features/FindSpecialist/store/findSpecialistService';
import { Dictionary, Nullable } from '@utils/util.types';
import { Dayjs } from 'dayjs';
import i18next from 'i18next';
import * as Yup from 'yup';

const { t } = i18next;

export interface SearchFormValues {
	crops: Nullable<Dictionary>;
	userLanguages: Dictionary[];
	code: string;
	crop_area: string;
	crop_unit: Dictionary;
	crop_latitude: number;
	crop_longitude: number;
	crop_location_name: string;
	specialist_id?: string[];
	consultationType: RequestType | null;
	startDate: Nullable<Dayjs>;
	endDate: Nullable<Dayjs>;
	service_id?: string[];
}

export type ExpressFormValues = Omit<
	SearchFormValues,
	'consultationType' | 'startDate' | 'endDate'
>;

export const cropUnitOptions: Dictionary[] = [
	{
		name: t('unitTypes.m2'),
		id: 'm2',
	},
	{
		name: t('unitTypes.hectares'),
		id: 'hectares',
	},
	{
		name: t('unitTypes.acres'),
		id: 'acres',
	},
];

export const expressInitialValues: ExpressFormValues = {
	crops: null,
	crop_latitude: 0,
	crop_longitude: 0,
	crop_location_name: '',
	userLanguages: [],
	service_id: [],
	code: '',
	crop_area: '',
	crop_unit: { name: t('unitTypes.hectares'), id: 'hectares' },
};

export const findSpecialistInitialValues: SearchFormValues = {
	...expressInitialValues,
	consultationType: 'ONE_TIME',
	startDate: null,
	specialist_id: [],
	endDate: null,
};

export const findSpecialistValidationSchema = Yup.object({
	crop_location_name: Yup.string(),
	crop_latitude: Yup.number(),
	crop_longitude: Yup.number(),
	consultationType: Yup.string().oneOf(['ONE_TIME', 'SEASONAL']),
	userLanguages: Yup.array().min(1, 'fieldNameError'),
	crops: Yup.object().required('fieldNameError'),
	crop_area: Yup.string().required('fieldNameError'),
	crop_unit: Yup.object().required('fieldNameError'),
	code: Yup.string(),
	startDate: Yup.date().when('consultationType', {
		is: 'SEASONAL',
		then: (schema) => schema.required('Start date is required for seasonal consultation'),
		otherwise: (schema) => schema.nullable(),
	}),
	endDate: Yup.date().when('consultationType', {
		is: 'SEASONAL',
		then: (schema) => schema.required('End date is required for seasonal consultation'),
		otherwise: (schema) => schema.nullable(),
	}),
});

export const expressValidationSchema = Yup.object({
	crop_location_name: Yup.string(),
	crop_latitude: Yup.number(),
	crop_longitude: Yup.number(),
	userLanguages: Yup.array().min(1, 'fieldNameError'),
	crops: Yup.object().required('fieldNameError'),
	crop_area: Yup.string().required('fieldNameError'),
	crop_unit: Yup.object().required('fieldNameError'),
	code: Yup.string(),
	service_id: Yup.array().min(1, 'fieldNameError'),
});

export interface LocationCoordinates {
	lat: number;
	lng: number;
}
